import React from 'react';
import { useDropzone } from 'react-dropzone';
import styles from './dropZone.module.scss';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import AddIcon from '@mui/icons-material/Add';
import { openNotification } from 'tt-ui-lib/core';

export const DropZone = ({ onDropped, page = null }) => {
  const acceptConfig = {
    'application/pdf': ['.pdf'],
    'text/plain': ['.txt'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
  };

  if (page === 'tutorial') {
    acceptConfig['video/mp4'] = ['.mp4'];
  }
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: acceptConfig,
    multiple: false,
    onDrop: (files) => onDropped(files, 'files'),
    onDropRejected: () => {
      openNotification({
        message: 'File type must be .pdf, .txt, .jpg, .jpeg or .png',
        type: 'error',
      });
    },
  });

  return (
    <div className={styles.dropzoneArea}>
      <div className={styles.dropzone} {...getRootProps()}>
        <input {...getInputProps()} />
        <div className={styles.dropzoneContainer}>
          <div className={styles.dropzoneTextRow}>
            <NoteAddIcon />
            <p>Drag files here</p>
          </div>
          <p className={styles.dropzoneSubtitle}>You can add file with the maximum size 700 MB</p>
        </div>
      </div>
      <div className={styles.dropzoneUpload}>
        <label className={styles.dropzoneRow}>
          <input {...getInputProps()} />
          <AddIcon color="primary" />
          <span>Choose file</span>
        </label>
        <div className={styles.dropzoneRow}>
          <img src="/images/Dropbox.png" alt="Dropbox" />
          <p>dropbox</p>
        </div>
        <div className={styles.dropzoneRow}>
          <img src="/images/GoogleDrive.png" alt="GoogleDrive" />
          <p>google drive</p>
        </div>
        <div className={styles.dropzoneRow}>
          <img src="/images/Icloud.png" alt="Icloud" />
          <p>icloud</p>
        </div>
      </div>
    </div>
  );
};
